/* Version: 3.5.137 */
'use client';
import 'react';
import { VisuallyHidden } from 'react-aria';
import PropTypes from 'prop-types';
import i18n from '../../lang/i18n/index.js';
import { noop } from '../../utils/functions.js';
import { ShowPasswordToggleWrapper } from './styledComponents.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import useLang from '../../hooks/useLang.js';

var ShowPasswordToggle = function ShowPasswordToggle(_ref) {
  var id = _ref.id,
    _ref$show = _ref.show,
    show = _ref$show === undefined ? false : _ref$show,
    _ref$toggle = _ref.toggle,
    toggle = _ref$toggle === undefined ? noop : _ref$toggle,
    theme = _ref.theme;
  var lang = useLang();
  var ariaLabel = show ? "".concat(i18n[lang].textInput.hidePasswordAriaLabel, ", ").concat(i18n[lang].textInput.passwordDisplayed) : "".concat(i18n[lang].textInput.showPasswordAriaLabel, ", ").concat(i18n[lang].textInput.passwordHidden);
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(VisuallyHidden, {
      children: /*#__PURE__*/jsx("div", {
        "aria-live": "polite",
        children: show ? i18n[lang].textInput.passwordNowDisplayed : i18n[lang].textInput.passwordNowHidden
      })
    }), /*#__PURE__*/jsx(ShowPasswordToggleWrapper, {
      id: id,
      onClick: toggle,
      theme: theme,
      type: "button",
      "aria-label": ariaLabel,
      children: /*#__PURE__*/jsx("span", {
        "aria-hidden": "true",
        children: show ? i18n[lang].textInput.hide : i18n[lang].textInput.show
      })
    })]
  });
};
process.env.NODE_ENV !== "production" ? ShowPasswordToggle.propTypes = {
  id: PropTypes.string,
  show: PropTypes.bool,
  toggle: PropTypes.func,
  // eslint-disable-next-line react/forbid-prop-types
  theme: PropTypes.object.isRequired
} : undefined;
process.env.NODE_ENV !== "production" ? ShowPasswordToggle.displayName = 'ShowPasswordToggle' : undefined;

export { ShowPasswordToggle as default };
